export default "__VITE_ASSET__db941e88__"